import { render, staticRenderFns } from "./noticeinfo.vue?vue&type=template&id=07552c9c&scoped=true&"
import script from "./noticeinfo.vue?vue&type=script&lang=js&"
export * from "./noticeinfo.vue?vue&type=script&lang=js&"
import style0 from "./noticeinfo.vue?vue&type=style&index=0&id=07552c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07552c9c",
  null
  
)

export default component.exports